module.exports = __webpack_public_path__ + "55649dc16f35654d550f26ba0379307e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-20@2x.png
// module id = 506
// module chunks = 0